import { Grid, InputAdornment, Typography } from '@mui/material'
import React, { Dispatch } from 'react'
import { ChargeRate, Taxi } from '../../../../api/vehicle/taxisAPI.types'
import FormInput from '../../../FormFields/FormInput/FormInput'
import styles from '../manageSupplierStyle'

interface Props {
  taxi?: Taxi | undefined
  waitingTime: string
  chargeRates: Array<ChargeRate>
  setChargeRates: Dispatch<React.SetStateAction<Array<ChargeRate>>>
  isEdit: boolean
  additionalStop: boolean
  waitAndReturn: boolean
  displayOrder?: number[]
}
interface ChargeRateException {
  chargeExceptionId: number
  chargeTypeName?: string
  premium?: number
  percentage?: number
}

export const DayRateRow = (props: Props) => {
  const {
    taxi,
    waitingTime,
    chargeRates,
    setChargeRates,
    isEdit,
    additionalStop,
    waitAndReturn,
    displayOrder,
  } = props
  const order = displayOrder ?? chargeRates.map((_, idx) => idx)

  const handleChangeEvent = (
    event: React.BaseSyntheticEvent,
    index: number,
  ) => {
    const value: number = event.target.value
    const clonedRates: Array<ChargeRate> = [...chargeRates]
    let mappedExceptions: Array<ChargeRateException> = []
    const rate = clonedRates[index]
    rate.chargeExceptions.map((exception: any) => {
      if (exception.chargeTypeName === 'Percentage') {
        const percentage = exception?.percentage || 0
        let newPremium =
          (Number(percentage) / 100) * Number(value) + Number(value)
        mappedExceptions.push({
          ...exception,
          premium: newPremium,
        })
      } else {
        mappedExceptions.push(exception)
      }
    })
    clonedRates[index] = rate
    setChargeRates([...clonedRates])
  }

  return (
    <Grid container spacing={2} direction="row" alignItems="center">
      <Grid item xs={1}>
        <Typography>Day rate hours</Typography>
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={1} />
      <Grid item xs={1}>
        <FormInput
          name={'vehicle.minimumFare.price'}
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
          }}
          type="tel"
          sx={styles.inputField}
          disabled={!isEdit}
          defaultValue={
            taxi?.minimumFare?.price
              ? Number(taxi?.minimumFare?.price).toFixed(2)
              : ''
          }
        />
      </Grid>
      {waitingTime === 'grace' && (
        <Grid item xs={1}>
          <FormInput
            name={'vehicle.waitingTime.gracePeriod.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxi?.waitingTime?.gracePeriod?.price
                ? Number(taxi?.waitingTime?.gracePeriod?.price).toFixed(2)
                : ''
            }
          />
        </Grid>
      )}
      {waitingTime !== '' && (
        <Grid item xs={1}>
          <FormInput
            name={'vehicle.waitingTime.chargingPeriod.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxi?.waitingTime?.chargingPeriod?.price
                ? Number(taxi?.waitingTime?.chargingPeriod?.price).toFixed(2)
                : ''
            }
          />
        </Grid>
      )}
      {waitAndReturn && (
        <Grid item xs={1}>
          <FormInput
            name={'vehicle.waitAndReturn.chargingPeriod.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxi?.waitAndReturn?.chargingPeriod?.price
                ? Number(taxi?.waitAndReturn?.chargingPeriod?.price).toFixed(2)
                : ''
            }
          />
        </Grid>
      )}
      {additionalStop && (
        <Grid item xs={1}>
          <FormInput
            name={'vehicle.additionalStop.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxi?.additionalStop?.price
                ? Number(taxi?.additionalStop?.price).toFixed(2)
                : ''
            }
          />
        </Grid>
      )}
      {order.map((i) => {
        const chargeRate = chargeRates[i]
        if (!chargeRate) return null
        return (
          <Grid item key={i} xs={1}>
            <FormInput
              name={`chargeRates[${i}].pricePerMile`}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">£</InputAdornment>
                ),
              }}
              type="tel"
              sx={styles.inputField}
              onChange={(event) => handleChangeEvent(event, i)}
              disabled={!isEdit}
              defaultValue={
                chargeRates[i].pricePerMile
                  ? Number(chargeRates[i].pricePerMile).toFixed(2)
                  : ''
              }
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
export default DayRateRow
